import { render } from "./DetailProduct.vue?vue&type=template&id=fcf46162"
import script from "./DetailProduct.vue?vue&type=script&lang=js"
export * from "./DetailProduct.vue?vue&type=script&lang=js"

import exportComponent from "/Users/teguhsangra/Web/GSD/xsport/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__